const numbers = {
  xs: 340,
  sm: 500,
  md: 800,
  lg: 1280,
  xl: 1920
}

const media = {
  up: breakpointName => `@media (min-width: ${numbers[breakpointName]}px)`,
  down: breakpointName => `@media (max-width: ${numbers[breakpointName]}px)`
}

export const breakpoints = {
  ...numbers,
  ...media
}
